import React from 'react'

import Reflux from 'reflux-react-16'
import moment from 'moment'
import _ from 'underscore'
import csvExport from '../../utils/csvExport.js'
import filter from '../../utils/filter.js'

import CustomerStore from '../../stores/CustomerStore.js'
import CustomerActions from '../../actions/CustomerActions.js'
import AddressStore from '../../stores/AddressStore.js'
import AddressActions from '../../actions/AddressActions.js'
import ParcelStore from '../../stores/ParcelStore.js'
import UserStore from '../../stores/UserStore.js'
import LoginStore from '../../stores/LoginStore.js'
import LoginActions from '../../actions/LoginActions.js'

import CustomerModal from '../../components/customers/CustomerModal.js'
import ImportCustomers from '../../components/customers/ImportCustomers.js'
import {Button, IconButton, Colors, Popup, Panel, P} from '../../components/UI/index.js'
import {openMfaPopup, showMfaContinue} from '../../components/login/mfaPopup.js'
import {formSpacing, Toggle} from '../../components/UI/forms/index.js'
import Table from '../../components/UI/table/index.js'
import SearchBar from '../../components/SearchBar/index.js'

import webshopKeyToName from '../../utils/webshopNames.js'
import t from 'src/helpers/Languages.js'
import {getAvailableBranches} from '../../utils/branches.js'
import branchesAvailable from '@utils/branchesAvailable.js'
import {openHandoverTab, sendToken} from '../../utils/loginAsHandover.js'
import createMemo from '../../utils/createMemo.js'

class Customers extends Reflux.Component {
    constructor(props) {
        super(props)

        this.columnsMemo = createMemo()

        this.stores = [CustomerStore, ParcelStore, UserStore, AddressStore, LoginStore]

        this.state = {
            showArchived: false
        }
    }

    componentDidMount() {
        const {reseller} = this.props

        document.title = `Klanten • ${reseller.settings.accountName || reseller.name}`
    }

    // The same columns until a value they read changes: new columns re-render every row of the table
    columns() {
        return this.columnsMemo([this.props.reseller], () => this.buildColumns())
    }

    buildColumns() {
        const {reseller} = this.props

        const columns = [
            ...branchesAvailable(reseller) ?
                [{id: 'branchName', title: t('branch'), visible: false, key: 'branchName', width: 180, text: (customer) => {
                    const branch = reseller.settings.branches?.find((branch) => branch.id === customer?.branchId)
                    return branch?.name || ''
                }}] :
                [],
            {id: 'synced', title: 'Sync', visible: true, key: 'synced', width: 50, onClick: () => {}, render: (customer) => {
                return (
                    <i style={{fontSize: 12, color: customer.synced ? Colors.successBright : Colors.warningBright}} className='mdi mdi-circle' />
                )
            }},
            {id: 'debtorCode', title: 'Debiteurnummer', visible: true, key: 'debtorCode', width: 150},
            {id: 'name', title: 'Naam', visible: true, key: 'name', flex: 1},
            {id: 'address', title: 'Adres', visible: true, flex: 1, text: (customer) => {
                const address = customer.address

                return `${address.street} ${address.nr}${address.addition}`
            }},
            {id: 'address.postalCode', title: 'Postcode', visible: true, key: 'address.postalCode', width: 120},
            {id: 'address.city', title: 'Plaats', visible: true, key: 'address.city', flex: 1},
            {id: 'phone', title: 'Telefoon', visible: true, key: 'phone', width: 150},
            {id: 'email', title: 'Emailadres', visible: true, key: 'email', flex: 1},
            {id: 'settings.parcels.priceTable', title: 'Tarieftabel Nederland', visible: false, key: 'settings.parcels.priceTable', flex: 1, sort: (customer) => {
                return customer.settings.parcels.priceTable || 'Standaard'
            }, text: (customer) => {
                return customer.settings.parcels.priceTable || 'Standaard'
            }},
            {id: 'settings.parcels.priceTableAbroad', title: 'Tarieftabel buitenland', visible: false, key: 'settings.parcels.priceTableAbroad', flex: 1, sort: (customer) => {
                return customer.settings.parcels.priceTableAbroad || customer.settings.parcels.priceTable || 'Standaard'
            }, text: (customer) => {
                return customer.settings.parcels.priceTableAbroad || customer.settings.parcels.priceTable || 'Standaard'
            }},
            {id: 'lastInvoice', title: 'Laatste factuur', visible: false, key: 'lastInvoice', flex: 1, text: (customer) => {
                return customer.lastInvoice ? moment(customer.lastInvoice).format('DD-MM-YYYY') : ''
            }, sort: (customer) => customer.lastInvoice},
            {id: 'lastActive', title: 'Laatst actief', visible: true, key: 'lastActive', flex: 1, text: (customer) => {
                return customer.lastActive ? moment(customer.lastActive).format('DD-MM-YYYY HH:mm') : ''
            }, sort: (customer) => customer.lastActive},
            {id: 'settings.parcels.autoPickupPrice', title: 'Prijs ophaalrit', visible: false, width: 100, key: 'settings.parcels.autoPickupPrice', text: (customer) => {
                return customer.settings.parcels.autoPickupOrder && customer.settings.parcels.autoPickupPrice ? `€ ${customer.settings.parcels.autoPickupPrice}` : ''
            }},
            {id: 'attachments', title: 'Bijlage', visible: false, key: 'attachments', flex: 1, onClick: () => {}, render: (customer) => {
                const address = customer.address
                return (
                    <P
                        onClick={() => {
                            const attachment = address.attachments?.[0] || {}
                            const openUrl = (file) => {
                                const raw = window.atob(file)
                                const rawLength = raw.length
                                const array = new Uint8Array(new ArrayBuffer(rawLength))

                                for (let i = 0; i < rawLength; i++) {
                                    array[i] = raw.charCodeAt(i)
                                }

                                const blob = new Blob([array], {type: attachment.type})

                                const blobUrl = URL.createObjectURL(blob)

                                window.open(blobUrl)
                            }
                            if (attachment.fileId) {
                                AddressActions.downloadAttachment(attachment.fileId, (err, file) => {
                                    if (err) {
                                        console.log(err)
                                    } else {
                                        openUrl(file)
                                    }
                                })
                            } else if (attachment.data) {
                                window.open(attachment.data)
                            }
                        }}
                        ellipsis
                    >
                        {address.attachments?.map((a) => a.fileName).join(',')}
                    </P>
                )
            }},
            {id: 'login', title: 'Login', visible: false, key: 'login', width: 100, text: (customer) => {
                return customer.login ? 'Ja' : 'Nee'
            }},
            {id: 'connections', title: 'Webshop koppelingen', visible: false, key: 'connections', width: 200, text: (customer) => {
                let connections = []

                Object.keys(customer.settings.webshops).map((webshop) => {
                    if (customer.settings.webshops[webshop]?.active) {
                        connections.push(webshopKeyToName[webshop] || webshop)
                    }
                })

                return connections.sort().join(', ')
            }, sort: (customer) => {
                let connections = []

                Object.keys(customer.settings.webshops).map((webshop) => {
                    if (customer.settings.webshops[webshop]?.active) {
                        connections.push(webshopKeyToName[webshop] || webshop)
                    }
                })

                return connections.sort().join(', ')
            }},
            {id: 'isArchived', title: 'Gearchiveerd', visible: false, key: 'isArchived', width: 100, text: (customer) => {
                return customer.isArchived ? 'Ja' : 'Nee'
            }},
            {id: 'edit', visible: true, showOnHover: true, width: 50, render: (customer) => {
                return (
                    <IconButton onClick={this.onClickEdit.bind(this, customer)}>
                        <i className='mdi mdi-pencil' />
                    </IconButton>
                )
            }}
        ]

        return columns
    }

    onChangeQueries(customerQueries) {
        this.table.selectPage(1)
        CustomerActions.setQueries(customerQueries)
    }

    onChangeTable(selectedCustomers) {
        CustomerActions.setSelected(selectedCustomers)
    }

    onClickNew() {
        this.modal.open()
        CustomerActions.setSelected([])
    }

    onClickEdit(customer) {
        this.modal.open(customer)
    }

    onClickToggleArchive(_event, deArchive = false) {
        const {selectedCustomers, customers} = this.state
        const {reseller} = this.props

        if (deArchive) {
            const customersToBeDeArchived = []

            selectedCustomers.forEach((id) => {
                if (customers[id]?.isArchived) {
                    customersToBeDeArchived.push(id)
                }
            })

            this.popup.open('Klant dearchiveren', `${customersToBeDeArchived.length} ${customersToBeDeArchived.length === 1 ? 'klant wordt' : 'klanten worden'} weer actief gemaakt voor gebruik.`, () => {
                CustomerActions.setSelected([])

                CustomerActions.toggleArchive(customersToBeDeArchived, (err) => {
                    if (err) {
                        this.popup.setError(err)
                    } else {
                        this.popup.close()
                    }
                })
            })
        } else {
            const customersToBeArchived = []

            selectedCustomers.forEach((id) => {
                if (!customers[id]?.isArchived) {
                    customersToBeArchived.push(id)
                }
            })

            this.popup.open('Klant archiveren', `${customersToBeArchived.length} ${customersToBeArchived.length === 1 ? 'klant wordt' : 'klanten worden'} gearchiveerd.${reseller.settings.administration.api ? `\nKlanten worden niet gearchiveerd in ${reseller.settings.administration.api}.` : ''}`, () => {
                CustomerActions.setSelected([])

                CustomerActions.toggleArchive(customersToBeArchived, (err) => {
                    if (err) {
                        this.popup.setError(err)
                    } else {
                        this.popup.close()
                    }
                })
            })
        }
    }

    async onClickAssignBranch() {
        const {selectedCustomers, customers} = this.state
        const {reseller} = this.props

        const availableBranches = getAvailableBranches(reseller)

        this.popup.setInputs([
            {label: t('branch'), name: 'branchId', value: '', type: 'select', options: [{value: '', title: t('noBranch')}, ...availableBranches.map((branch) => ({value: branch.id, title: branch.name}))]}
        ])

        const values = await this.popup.open(t('assignBranch'), t('chooseBranchForCustomers'))
        if (!values) return

        CustomerActions.setSelected([])

        const branchId = values.branchId || ''

        let success = 0
        const errors = []
        this.popup.setProgress(0, selectedCustomers.length)

        for (const id of selectedCustomers) {
            const customer = customers[id]

            if (!customer) {
                continue
            }

            await new Promise((resolve) => {
                CustomerActions.edit({...customer, branchId}, (err) => {
                    if (err) {
                        errors.push(err)
                    } else {
                        success += 1
                    }

                    this.popup.setProgress(success + errors.length, selectedCustomers.length)
                    resolve()
                })
            })
        }

        this.popup.setMessage(`${success} ${success === 1 ? 'klant' : 'klanten'} bewerkt.`)
        this.popup.setErrors(errors)
    }

    onClickSync() {
        this.popup.open('Synchroniseer klanten', 'Dit kan enkele minuten duren.', () => {
            CustomerActions.setSelected([])

            CustomerActions.sync((err, res) => {
                if (err) {
                    this.popup.setError(err)
                } else {
                    this.popup.setMessage(`${res.new} nieuwe ${res.new === 1 ? 'klant' : 'klanten'}, ${res.synced} ${res.synced === 1 ? 'klant' : 'klanten'} gesynchroniseerd.`)

                    this.popup.setErrors(res.errors)
                }

                AddressActions.get()
            })
        })
    }

    onClickImport() {
        this.importModal.open()
        CustomerActions.setSelected([])
    }

    async onClickExport() {
        const {customers, selectedCustomers} = this.state
        const exportCustomers = []

        selectedCustomers.map((id) => {
            const customer = customers[id]
            if (customer) {
                exportCustomers.push(customer)
            }
        })

        await this.popup.openProgress(t('export'), '', (onProgress) => csvExport.customers(exportCustomers, onProgress))

        CustomerActions.setSelected([])
    }

    onClickLogin() {
        const {customers, selectedCustomers} = this.state

        const customer = customers[selectedCustomers[0]]
        if (customer) {
            LoginActions.loginAsCustomer(customer, (err, loginWithMfa) => {
                if (err) {
                    this.popup.open(t('errorMessage'), '', () => {})
                    this.popup.setError(err)
                }
                if (typeof loginWithMfa === 'function') {
                    this.popup.open(t('loginAsCustomerMfaTitle'), t('loginAsCustomerMfaText'), () => {
                        // The code popup replaces this one once the code is mailed (or right away for an app code)
                        loginWithMfa((err) => {
                            if (err) {
                                delete sessionStorage.customerToken
                                this.popup.setError(err)
                                return
                            }

                            openMfaPopup(this.popup, {
                                mfaMethod: customer.mfaMethod,
                                confirmLabel: t('mfaConfirm'),
                                // The pending customer token would otherwise be used for this account's own 2FA calls
                                onClose: () => delete sessionStorage.customerToken,
                                onLogin: (code) => {
                                    LoginActions.verify2FACode(code, (err, verifiedToken) => {
                                        if (err) {
                                            this.popup.setError(err)
                                        } else {
                                            const token = verifiedToken || sessionStorage.customerToken
                                            delete sessionStorage.customerToken

                                            // A new tab is only allowed in a click, so ask for one more
                                            showMfaContinue(this.popup, t('loginAsCustomerMfaVerified'), t('openCustomerPortal'), () => {
                                                sendToken(openHandoverTab(), token, '/klant')
                                            })
                                        }
                                    })
                                }
                            })
                        })
                    })
                }
            })
        }
    }

    onClickSendWelcomeEmail() {
        const {selectedCustomers, customers} = this.state

        const customersToSend = []

        selectedCustomers.map((id) => {
            const customer = customers[id]

            if (customer.login && customer.loginEmail) {
                customersToSend.push(customer)
            }
        })

        this.popup.open('Verstuur welkomstmail', `Weet je zeker dat je ${customersToSend.length} welkomstmail${customersToSend.length === 1 ? '' : 's'} wilt versturen?`, async () => {
            const errors = []

            for (const customer of customersToSend) {
                await new Promise((resolve) => {
                    LoginActions.sendCustomerWelcomeMail(customer, (err) => {
                        if (err) {
                            errors.push(err)
                        }

                        resolve()
                    })
                })
            }

            if (errors.length > 0) {
                this.popup.setError(errors)
            } else {
                this.popup.setMessage('Welkomstmails zijn verstuurd.')
            }
        })
    }

    render() {
        const {selectedCustomers, customersLoading, customerQueries, carriers, showArchived} = this.state
        let {customers: stateCustomers} = this.state
        const {reseller, user} = this.props

        stateCustomers = _.pick(stateCustomers, (customer) => {
            return showArchived || !customer.isArchived
        })

        const customers = filter.customers(_.values(stateCustomers), customerQueries, reseller)
        const availableBranches = getAvailableBranches(reseller)

        return (
            <div style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
                <Panel style={{display: 'flex', columnGap: formSpacing.columnGap, borderTop: 'none', borderLeft: 'none', borderRight: 'none', background: Colors.backgroundNeutral, padding: '20px 10px 10px 10px'}}>

                    <SearchBar
                        columns={this.columns().filter((column) => column.key !== 'isArchived')}
                        onQueryChange={this.onChangeQueries.bind(this)}
                        queries={customerQueries}
                    />

                    {(!reseller.settings.administration.api || !reseller.settings.administration.noNewCustomers) &&
                        <Button
                            variant='outline-white'
                            onClick={this.onClickNew.bind(this)}
                        >Nieuwe Klant
                        </Button>
                    }

                    {reseller.settings.administration.api && reseller.settings.administration.syncCustomers &&
                        <Button
                            variant='outline-white'
                            onClick={this.onClickSync.bind(this)}
                        >
                            <i className='mdi mdi-refresh' />
                        </Button>
                    }

                    {(!reseller.settings.administration.api || !reseller.settings.administration.noNewCustomers) &&
                        <Button
                            variant='outline-white'
                            onClick={this.onClickImport.bind(this)}
                        >
                            <i className='mdi mdi-file-import' />
                        </Button>
                    }

                    {selectedCustomers.length > 0 &&
                        <>
                            <Button
                                variant='outline-white'
                                onClick={this.onClickExport.bind(this)}
                            >
                                <i className='mdi mdi-file-export' />
                            </Button>

                            <Button
                                variant='outline-white'
                                onClick={this.onClickToggleArchive.bind(this)}
                                tooltip='Archiveren'
                            >
                                <i className='mdi mdi-archive' />
                            </Button>

                            {showArchived &&
                                <Button
                                    variant='outline-white'
                                    onClick={this.onClickToggleArchive.bind(this, true)}
                                    tooltip='Dearchiveren'
                                >
                                    <i className='mdi mdi-archive-off' />
                                </Button>
                            }

                            {availableBranches.length > 0 &&
                                <Button
                                    variant='outline-white'
                                    onClick={this.onClickAssignBranch.bind(this)}
                                    tooltip={t('assignBranch')}
                                >
                                    <i className='mdi mdi-office-building-marker-outline' />
                                </Button>
                            }

                            <Button
                                variant='outline-white'
                                onClick={this.onClickSendWelcomeEmail.bind(this)}
                            >
                                Verstuur welkomstmail
                            </Button>
                        </>
                    }

                    {selectedCustomers.length === 1 &&
                        <Button
                            variant='outline-white'
                            onClick={this.onClickLogin.bind(this)}
                        >
                            <i className='mdi mdi-login' />
                        </Button>
                    }

                    <Toggle
                        style={{width: 'fit-content', marginLeft: 'auto'}}
                        label='Toon gearchiveerde klanten'
                        checked={showArchived}
                        onChange={(event) => this.setState({showArchived: event.target.checked})}
                    />

                </Panel>

                <div style={{flex: 1, marginTop: 24, marginRight: 24, marginLeft: 24}}>
                    <Table
                        tableName='customers'
                        columns={this.columns()}
                        rows={customers}
                        selectedRows={selectedCustomers}
                        loading={customersLoading}
                        onChange={this.onChangeTable.bind(this)}
                        ref={(ref) => this.table = ref}
                    />
                </div>

                <CustomerModal
                    ref={(modal) => this.modal = modal}
                    reseller={reseller}
                    customers={this.state.customers}
                    user={user}
                    carriers={carriers}
                    partners={this.state.partners}
                />

                <ImportCustomers
                    ref={(modal) => this.importModal = modal}
                />

                <Popup ref={(modal) => this.popup = modal} />
            </div>
        )
    }
}

export default (Customers)
